import React from 'react';
import { Navigation } from './Navigation';
import { Section } from './Section';

const UploadPage = () => {
  return (
    <div>
      <Navigation />
      <Section />
    </div>
  );
};

export default UploadPage;
